export interface AllySuggestionsProps {
  suggestions: ReadonlyArray<string>;
  onPick: (s: string) => void;
  disabled?: boolean;
}

export function AllySuggestions({ suggestions, onPick, disabled }: AllySuggestionsProps) {
  return (
    <div className="ally__sugg">
      {suggestions.map((s) => (
        <button
          key={s}
          type="button"
          onClick={() => onPick(s)}
          disabled={disabled}
        >
          {s}
        </button>
      ))}
    </div>
  );
}
